import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import * as Ms from '@microsoft/teams-js';
import { _getItemFromLocalDecrypted } from 'network-helper';
import bellIcon from "../../images/bell.png";
import Input from '../VaccinationDetails/VaccinationDetailsWrapper/Components/InputForm';
import { _setItemInLocal } from '../../utils/LocalKeys';
import { teams_app_id } from "../../config.json";

import "./linkCorporateModal.css";

const LinkCorporateModal = ({ showLinkMsgType, _closeLinkModal }) => {
  const [name, setName] = useState("");

  useEffect(() => {
    const currentProfile = JSON.parse(_getItemFromLocalDecrypted("_cp"));
    if (currentProfile !== null) {
      const profileName = _.get(currentProfile, "name", "");
      setName(profileName);
    }
  }, [])

  const handleDeepLink = (tabId) => {
    _setItemInLocal("_rurl", "/Vaccination/profile/manage-ids/linknew-ids");
    Ms.initialize()
    Ms.executeDeepLink(
      "https://teams.microsoft.com/l/entity/" + tabId
    );
    _closeLinkModal();
  }

  return (
    <div>
      <div
        className="link-modal-overlay"
        onClick={_closeLinkModal}
      ></div>
      <div className="link-modal-body">
        <img className="bell-icon" src={bellIcon} alt="bell-icon" />
        <div className="link-text-wrapper">
          <div className="link-modal-heading">{`Hi ${name}`},</div>
          <div className="link-modal-text">{showLinkMsgType === "1" ? "We have linked your Corporate ID Against This Account" : "Request you to link your Corporate Identity with the help of Manage Identity in Vaccination PNP"}</div>
          <div className="link-modal-buttons">
            <Input
              type="button"
              addClassInput="link-modal-button-no"
              value={showLinkMsgType === "1" ? "" : "Cancel"}
              onClick={showLinkMsgType === "1" ? "" : _closeLinkModal}
            />
            <Input
              type="button"
              addClassInput="link-modal-button-yes"
              value={showLinkMsgType === "1" ? "Dismiss" : "Link Corporate ID"}
              onClick={showLinkMsgType === "1" ? _closeLinkModal : () => handleDeepLink(`${teams_app_id}/04`)} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default LinkCorporateModal;